import { Typography } from "@/frontend/shared/ui/Typography/Typography";
import styles from "./WebsiteCell.module.scss";
import { addProtocol } from "@/frontend/shared/lib/urls/addProtocol";

export function WebsiteCell({ field }: { field: string }) {
  return (
    <a
      href={field ? addProtocol(field) : "-"}
      target="_blank"
      rel="noreferrer"
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <Typography variant={"label-4"} className={styles.websiteCell} color="greyscale900">
        {field}
      </Typography>
    </a>
  );
}
